import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const Studio = lazy(() => import("./studio/Studio"));
const About = lazy(() => import("./components/Rights"));
const path = window.location.pathname.replace(/\/+$/, "");
const isStudio = path.startsWith("/studio");
const isAbout = path === "/about";

// the flipbook is a static page in public/flipbook; if a host's SPA fallback lands it here, hand over to the file
if (path === "/flipbook") window.location.replace(`/flipbook/index.html${window.location.search}${window.location.hash}`);
else ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {isStudio || isAbout ? (
      <Suspense fallback={null}>{isStudio ? <Studio /> : <About />}</Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
